/** STMT Info dates are "M/D/YYYY"; show them as "Oct 8, 2026". */
export function formatStatementDate(value: string | null | undefined): string | null {
  if (!value) return null;
  const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value.trim());
  const date = m ? new Date(Number(m[3]), Number(m[1]) - 1, Number(m[2])) : new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

/**
 * Parses a dollar amount typed by the patient ("1,175.5" -> 1175.5). Returns null when it isn't a
 * positive amount with at most two decimals.
 */
export function parsePaymentAmount(text: string): number | null {
  const cleaned = text.replace(/[$,\s]/g, "");
  if (!/^\d+(\.\d{0,2})?$/.test(cleaned)) return null;
  const n = Number(cleaned);
  return n > 0 ? n : null;
}

/** Patient-facing error for an amount, or "" when it can be charged (mirrors the API's check). */
export function paymentAmountError(amount: number | null, balanceDue: number): string {
  if (amount == null) return "Enter an amount in dollars and cents.";
  if (amount > balanceDue) return `The amount can't be more than the balance due (${usd.format(balanceDue)}).`;
  return "";
}

export const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
